module.exports = __webpack_public_path__ + "img/tractorUnitFrontRight.c52ec63c.svg";